import { isCustomizedType, reduce } from "et3-type-guards";

import i18nServerResponse from "../../constants/i18n-server-response";
import { getDateAsObject } from "../../core/et3-date";
import { post } from "../axios-post";

export const apiCallGetDataForOtherCSREffectivenessTable = async ({
  adminId,
  eventName,
  fromDate,
  toDate
}: {
  adminId: number;
  eventName: string;
  fromDate: Date;
  toDate: Date;
}) => {
  const { status, data, et3Error } = await post<{
    no_issue_count: number;
    minor_issue_count: number;
    major_issue_count: number;
  }>(`auditor/getOtherCSREffectivenessData`, {
    adminId,
    eventName,
    dateMinObject: getDateAsObject(fromDate),
    dateMaxObject: getDateAsObject(toDate)
  });
  if (
    status === "OK" &&
    !isCustomizedType<{
      errorCode: string;
      et3Message: string;
    }>(
      {
        errorCode: "ERROR",
        et3Message: "ERROR"
      },
      data
    )
  ) {
    return {
      data,
      status: "OK",
      code: "SUCCESS"
    };
  } else if (status === "ERROR") {
    const errorNumber = reduce(() => et3Error.errorNumber, 0);
    return {
      data: "",
      status: "ERROR",
      code: i18nServerResponse.get(errorNumber)
    };
  } else {
    return {
      data: "",
      status: "ERROR",
      code: "ERROR"
    };
  }
};
